type SafeStorage = {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
};

type Logger = {
  info: (message: string, context?: Record<string, unknown>) => void;
};

// gloss
export const captureInviteTag = (url: URL, storage: SafeStorage, logger: Logger): void => {
  const raw = url.searchParams.get('inviteTag');
  if (!raw) return;

  const decoded = decodeURIComponent(raw);
  if (!decoded) return;

  const existing = storage.getItem('inviteTag');
  if (decoded === existing) return;

  storage.setItem('inviteTag', decoded);
  logger.info('Captured inviteTag', { inviteTag: decoded });
};
